import React from "react";

import { Typography } from "@mui/material";

const Error = () => {
  return (
    <div>
      <Typography
        display="flex"
        textAlign="center"
        justifyContent="center"
        justifyItems="center"
        justifyself="center"
        paddingTop={25}
        paddingLeft={70}
        color="0000"
        fontSize={100}
        fontWeight={900}
      >
        404 Error
      </Typography>
    </div>
  );
};

export default Error;
